interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  label?: string;
}

const sizeClasses: Record<NonNullable<SpinnerProps['size']>, string> = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-10 w-10 border-4',
};

const Spinner = ({ size = 'md', label = 'Loading' }: SpinnerProps) => (
  <span
    role="status"
    aria-label={label}
    className={[
      'inline-block animate-spin rounded-full border-current border-t-transparent text-current',
      sizeClasses[size],
    ].join(' ')}
  />
);

export default Spinner;
